(function() {
	var banner = document.getElementById('p-desk-simulator-banner');
	if (!banner) return;

	var link = document.getElementById('p-desk-simulator-link');
	if (!link) return;

	var handle = banner.dataset.handle;
	var productType = (banner.dataset.productType || '').toLowerCase();
	var variants;
	try {
		variants = JSON.parse(banner.dataset.variants);
	} catch (e) {
		return;
	}

	// 天板タイプマッピング（metrodarkをmetroより先にチェック）
	var topKeys = ['metrodark', 'metro', 'studio', 'polar', 'dome', 'atelier', 'forest', 'grove'];
	var topMap = {
		'metrodark': 'metroDark', 'metro': 'metro', 'studio': 'studio', 'polar': 'polar',
		'dome': 'dome', 'atelier': 'atelier', 'forest': 'forest', 'grove': 'grove'
	};

	// Dashboard天板マッピング
	var dbTopKeys = ['matteblack', 'matte-black', 'mattewhite', 'matte-white', 'dome', 'atelier', 'forest', 'grove'];
	var dbTopMap = {
		'matteblack': 'matteBlack', 'matte-black': 'matteBlack',
		'mattewhite': 'matteWhite', 'matte-white': 'matteWhite',
		'dome': 'dome', 'atelier': 'atelier', 'forest': 'forest', 'grove': 'grove'
	};

	// Dashboard option1 → dbTopマッピング
	// "Matte White" → matteWhite, "Matte Black" → matteBlack, "DOME (ウォールナット)" → dome, etc.
	var dbModelMap = {
		'matte white': 'matteWhite', 'matte black': 'matteBlack',
		'dome': 'dome', 'atelier': 'atelier', 'forest': 'forest', 'grove': 'grove'
	};
	var dbModelKeys = ['matte white', 'matte black', 'dome', 'atelier', 'forest', 'grove'];

	// 商品ハンドルからシミュレーターの基本パラメータを取得
	function getHandleParams() {
		var params = {};
		if (productType === 'desk' || productType === 'board') {
			// シリーズの判定
			if (handle.indexOf('standing-plus') !== -1 || handle.indexOf('plus') !== -1) {
				params.series = 'standingPlus';
				params.leg = 'e7h';
			} else if (productType === 'board' && (handle.indexOf('e7pro') !== -1 || handle.indexOf('e7-pro') !== -1)) {
				params.series = 'boardE7Pro';
				params.leg = 'e7pro';
			} else {
				params.series = 'standing';
			}
			// 天板タイプの抽出
			for (var i = 0; i < topKeys.length; i++) {
				if (handle.indexOf(topKeys[i]) !== -1) {
					params.top = topMap[topKeys[i]];
					break;
				}
			}
			params.db = '0';
			params.drawer = '0';
		} else if (productType === 'dashboard') {
			params.db = '1';
			params.drawer = '0';
		}
		return params;
	}

	// DESK/BOARD: 選択中バリアントからサイズ・脚タイプ・カラーを取得
	// option1: "幅120cm × 奥行き70cm" → size
	// option2: "E7 (Black) 昇降脚セット" → leg, color / "天板のみ" → board only
	function getDeskVariantParams(variant) {
		var params = {};
		if (!variant) return params;

		// option1からサイズを抽出: "幅{w}cm × 奥行き{d}cm" → "{w}x{d}"
		var opt1 = variant.option1 || '';
		var sizeMatch = opt1.match(/(\d+)\s*cm\s*[×x]\s*[^\d]*(\d+)\s*cm/);
		if (sizeMatch) {
			params.size = sizeMatch[1] + 'x' + sizeMatch[2];
		}

		// option2から脚タイプとカラーを抽出: "E7 (Black) 昇降脚セット"
		var opt2 = variant.option2 || '';
		if (opt2 !== '天板のみ') {
			// 脚タイプ: E7 Pro > E7H > E8 > E7
			var legMatch = opt2.match(/E7\s*Pro/i);
			if (legMatch) {
				params.leg = 'e7pro';
			} else {
				legMatch = opt2.match(/E7H/i);
				if (legMatch) {
					params.leg = 'e7h';
				} else {
					legMatch = opt2.match(/E8/i);
					if (legMatch) {
						params.leg = 'e8';
					} else {
						legMatch = opt2.match(/E7/i);
						if (legMatch) {
							params.leg = 'e7';
						}
					}
				}
			}
			// カラー: (Black) or (White)
			var colorMatch = opt2.match(/\((Black|White)\)/i);
			if (colorMatch) {
				params.color = colorMatch[1].toLowerCase();
			}
		}

		return params;
	}

	// DASHBOARD→DESK対応マッピング
	// DASHBOARDモデル → { top, leg, color }
	var dbToDeskMap = {
		'matteBlack':  { top: 'metroDark', leg: 'e7', color: 'black' },
		'matteWhite':  { top: 'polar',     leg: 'e8', color: 'white' },
		'dome':        { top: 'dome',      leg: 'e7', color: 'black' },
		'atelier':     { top: 'atelier',   leg: 'e8', color: 'white' },
		'forest':      { top: 'forest',    leg: 'e7', color: 'black' },
		'grove':       { top: 'grove',     leg: 'e8', color: 'white' }
	};
	// DASHBOARDサイズ → DESKサイズ（奥行きは70固定）
	var dbToDeskSizeMap = { '100': '120x70', '120': '140x70', '140': '160x75' };

	// DASHBOARD: 選択中バリアントからdb系パラメータ + 対応DESK系パラメータを取得
	// option1: "Matte White" / "DOME (ウォールナット)" → dbTop, dbColor + DESK top/leg/color
	// option2: "幅100cm" → dbSize + DESK size
	// option3: "Steel Leg 高さ10cm" / "脚なし（天板のみ）" → dbHeight
	function getDashboardVariantParams(variant) {
		var params = {};
		if (!variant) return params;

		// option1 → dbTop（天板モデル）
		var opt1 = (variant.option1 || '').toLowerCase();
		var matchedDbTop = null;
		for (var i = 0; i < dbModelKeys.length; i++) {
			if (opt1.indexOf(dbModelKeys[i]) !== -1) {
				matchedDbTop = dbModelMap[dbModelKeys[i]];
				params.dbTop = matchedDbTop;
				break;
			}
		}
		// dbTop → dbColor対応
		var dbTopToColorMap = {
			'matteBlack': 'black', 'matteWhite': 'white',
			'dome': 'black', 'atelier': 'white',
			'forest': 'black', 'grove': 'white'
		};
		if (matchedDbTop && dbTopToColorMap[matchedDbTop]) {
			params.dbColor = dbTopToColorMap[matchedDbTop];
		}

		// DASHBOARDモデルに対応するDESKパラメータを設定
		if (matchedDbTop && dbToDeskMap[matchedDbTop]) {
			var deskMapping = dbToDeskMap[matchedDbTop];
			params.series = 'standing';
			params.top = deskMapping.top;
			params.leg = deskMapping.leg;
			params.color = deskMapping.color;
		}

		// option2 → dbSize: "幅100cm" → "100"
		var opt2 = variant.option2 || '';
		var sizeMatch = opt2.match(/(\d+)\s*cm/);
		if (sizeMatch && (sizeMatch[1] === '100' || sizeMatch[1] === '120' || sizeMatch[1] === '140')) {
			params.dbSize = sizeMatch[1];
			// DASHBOARDサイズに対応するDESKサイズを設定
			if (dbToDeskSizeMap[sizeMatch[1]]) {
				params.size = dbToDeskSizeMap[sizeMatch[1]];
			}
		}

		// option3 → dbHeight: "Steel Leg 高さ10cm" → "10", "Shaft Leg 高さ7.5cm" → "shaft-7.5"
		var opt3 = variant.option3 || '';
		var heightMatch = opt3.match(/高さ([\d.]+)\s*cm/);
		if (heightMatch) {
			if (opt3.indexOf('Shaft') !== -1) {
				params.dbHeight = 'shaft-' + heightMatch[1];
			} else {
				params.dbHeight = heightMatch[1];
			}
		}

		return params;
	}

	// productTypeに応じてバリアントパラメータを取得
	function getVariantParams(variant) {
		if (productType === 'dashboard') {
			return getDashboardVariantParams(variant);
		}
		return getDeskVariantParams(variant);
	}

	// URLからバリアントIDを取得して該当バリアントを返す
	function getCurrentVariant() {
		var urlParams = new URLSearchParams(window.location.search);
		var vid = urlParams.get('variant');
		if (vid) {
			var id = parseInt(vid);
			for (var i = 0; i < variants.length; i++) {
				if (variants[i].id === id) return variants[i];
			}
		}
		for (var i = 0; i < variants.length; i++) {
			if (variants[i].available) return variants[i];
		}
		return variants[0];
	}

	// 天板モデル → 脚カラーマッピング
	var topToColorMap = {
		'dome': 'black', 'atelier': 'white', 'forest': 'black', 'grove': 'white',
		'metro': 'black', 'metroDark': 'black', 'polar': 'white', 'studio': 'white'
	};

	// シミュレーターリンクを更新
	function updateSimulatorLink() {
		var handleParams = getHandleParams();
		var variantParams = getVariantParams(getCurrentVariant());
		var url = new URL('https://simulator.preducts.jp');
		var allParams = Object.assign({}, handleParams, variantParams);
		// バリアントにカラー指定がない場合のみ、天板モデルに応じた脚カラーを適用
		if (!variantParams.color && allParams.top && topToColorMap[allParams.top]) {
			allParams.color = topToColorMap[allParams.top];
		}
		for (var key in allParams) {
			if (allParams.hasOwnProperty(key)) {
				url.searchParams.set(key, allParams[key]);
			}
		}
		link.href = url.toString();
	}

	// 初期設定
	updateSimulatorLink();

	// バリアント変更を検知してリンクを更新
	var lastHref = location.href;
	var simObserver = new MutationObserver(function() {
		if (lastHref !== location.href) {
			lastHref = location.href;
			updateSimulatorLink();
		}
	});
	simObserver.observe(document, { childList: true, subtree: true });
})();
